<template>
  <div class="chat-library-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select v-model="param.prizeType" size="small" placeholder="请选择任务类型" clearable
        style="width:200px;margin-right:5px">
        <el-option v-for="item in type" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-select v-model="param.status" size="small" placeholder="请选择状态" clearable style="width:200px;margin-right:5px">
        <el-option v-for="item in statusType" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-button type="success" size="small" @click="searchBtn()">搜索</el-button>
      <el-button type="primary" size="small" @click="addContent('add')">+新增任务</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border v-loading="loading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" max-height="600">
      <el-table-column prop="createTime" label="创建时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="finishCondition"
        label="达成条件(天/活跃值)"
        align="center"
        min-width="120"
      ></el-table-column> -->
      <el-table-column prop="type" label="任务类型" align="center" :formatter="formatterType">
      </el-table-column>
      <el-table-column prop="cover" label="图片" align="center" min-width="180">
        <template slot-scope="scope">
          <img-load :src="imgUrl + scope.row.img" :width="'180px'" :height="'90px'" />
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="prizes"
        label="奖品列表"
        align="center"
        min-width="200"
        :formatter="formatterPrize"
      >
      </el-table-column> -->
      <el-table-column prop="title" label="任务标题" align="center" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.title || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="taskModel" label="任务模式" align="center" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.taskModel === 1 ? '一次性任务' : '每日任务' }}
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="任务描述" align="center" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.desc || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="sortNum" label="排序" align="center" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.sortNum || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="link" label="任务链接" align="center" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.link || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="count" label="状态" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="请在编辑中修改" placement="top-start">
            <el-switch v-model="scope.row.status" disabled></el-switch>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column min-width="120" label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-edit" @click="addContent('edit', scope.row)" round plain
            type="warning">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="param.pageNumber" :page-size="param.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" background @size-change="changeSize"
      @current-change="changeCurrent"></el-pagination>
    <add-content ref="addContent" @handlerContent="getContentList('status')" :prizeBox="prizeBox"></add-content>
  </div>
</template>
<script>
import API from "@/api";
import addContent from "./components/addContent";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      tableData: [],
      loading: false,
      total: 0,
      statusType: [
        {
          label: "启用",
          value: true,
        },
        {
          label: "禁用",
          value: false,
        },
      ],
      type: [
        {
          label: "每日广告点击",
          value: 0,
        },
        {
          label: "每日邀请",
          value: 1,
        },
        {
          label: "每日登录",
          value: 2,
        },
        {
          label: "每日评论",
          value: 3,
        },
        {
          label: "每日发布",
          value: 4,
        },

        {
          label: "购买vip",
          value: 5,
        },
        {
          label: "购买金币",
          value: 6,
        },
        {
          label: "绑定手机号",
          value: 7,
        },
        {
          label: "下载APP",
          value: 8,
        },
        {
          label: "神评",
          value: 9,
        },
        {
          label: "收藏",
          value: 10,
        },
      ],
      param: {
        pageNumber: 1,
        pageSize: 10,
        prizeType: "",
        status: "",
      },
      prizeBox: [],
    };
  },
  components: {
    addContent,
  },
  created() {
    this.getContentList();
    this.queryPrizeBox();
  },
  methods: {
    getParams() {
      let req = {
        pageNumber: this.param.pageNumber,
        pageSize: this.param.pageSize,
      };
      req.type = this.param.prizeType ? this.param.prizeType : undefined;
      req.status = this.param.status != null ? this.param.status : undefined;
      return req;
    },
    queryPrizeBox() {
      API.queryPrizeBox()
        .then((res) => {
          if (res.code === 200 && res.data.length > 0) {
            this.prizeBox = res.data;
            return;
          }
          this.$message.error(res.msg || "获取奖品失败");
          this.prizeBox = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getContentList() {
      this.loading = true;
      let req = this.getParams();
      API.getDailyActivity(req)
        .then((res) => {
          if (res.code === 200 && res.data.list.length > 0) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatterType(row) {
      return this.type.filter((item) => item.value == row.type).length > 0
        ? this.type.filter((item) => item.value == row.type)[0].label
        : "未知类型";
    },
    formatterPrize(row) {
      var htmlStr = "";
      if (this.prizeBox.length === 0 || row.prizes === 0) {
        return "获取奖品列表失败";
      }
      this.prizeBox.forEach((data) => {
        row.prizes.forEach((value) => {
          if (data.value == value) {
            htmlStr += "、" + data.label;
          }
        });
      });
      htmlStr = htmlStr.substr(1, htmlStr.length);
      return htmlStr;
    },
    searchBtn() {
      this.getContentList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size;
      this.param.pageNumber = 1;
      this.getContentList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber;
      this.getContentList();
    },
    // 打开编辑、添加弹窗
    addContent(type, data) {
      this.$refs.addContent.open(type, data);
    },
  },
};
</script>
